<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="exam_result"
      :columns="columns"
      :data="list"
      :total="count"
      :hideSearchInput="true"
      :hideAddButton="true"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { time } from '@/filters/time';
import { ExamUnitType } from '@/enums/examUnitType.enum';

// @vuese
// Lista wyników egzaminu
// @group Exam
export default {
  mixins: [
    listMixin('profile/examResults', {
      listError: 'messages.examResult.listError',
      getError: 'messages.examResult.getError',
      added: 'messages.examResult.added',
      addError: 'messages.examResult.addError',
      updated: 'messages.examResult.updated',
      updateError: 'messages.examResult.updateError',
      deleteConfirm: 'messages.examResult.deleteConfirm',
      deleted: 'messages.examResult.deleted',
      deleteError: 'messages.examResult.deleteError'
    })
  ],
  components: { ComponentTable },

  data() {
    return {
      columns: [
        {
          name: 'dateFormated',
          displayName: 'columns.date',
          sortable: true,
          sortName: 'date'
        },
        {
          name: 'scoreFormated',
          displayName: 'columns.score',
          sortable: false
        },
        {
          name: 'examName',
          displayName: 'columns.exam',
          sortable: false
        },
        {
          name: 'teamName',
          displayName: 'columns.team',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.profile.examResults.list.map(examResult => {
          examResult.scoreFormated =
            examResult.exam.unit === ExamUnitType.TIME ? time(examResult.score) : examResult.score;

          examResult.examName = examResult.exam.name;
          examResult.dateFormated = moment(examResult.date).format('DD-MM-Y');
          examResult.teamName = examResult.team.name;

          return examResult;
        }),
      count: state => state.profile.examResults.count
    })
  }
};
</script>
